const rules = {
  /*
  * 상품 플래그 정책 (24.12.24)
  * https://asungdaiso.atlassian.net/browse/DEV-4600
  * 오늘배송전용 플래그 정책 (전시) (25.01)
  * https://asungdaiso.atlassian.net/browse/QDV-1
  * */
  methods: {
    /**
     * 신상품 여부
     * @type { function(object): Boolean }
     */
    isNewProduct (item = {}) {
      return item.newPdYn === 'Y' || item.newPdYn === true || (Array.isArray(item.flag) && item.flag.includes('신상'))
    },
    /**
     * 택배전용 여부
     * 오직 onlyOnlYn === 'Y' 일 때에만 노출한다.
     * (매장픽업, 대량주문, 정기배송, 오늘배송 단 한개라도 면 미노출) - 2024.12.24 정책
     * @type { function(object): Boolean }
     */
    isOnlyOnlineProduct (item = {}) {
      return item.onlyOnlYn === 'Y' || item.onlyOnlYn === true || (Array.isArray(item.flag) && (item.flag.includes('택배전용') || item.flag.includes('온라인 전용')))
    },
    /**
     * 굿즈 여부
     * @type { function(object): Boolean }
     */
    isGoods (item = {}) {
      return (item.pdTy && item.pdTy === '04') || (item.goods !== undefined && item.goods !== null && item.goods !== '') || (Array.isArray(item.flag) && item.flag.includes('goods'))
    },
    /**
     * 박스상품 플래그 여부
     * @type { function(object): Boolean }
     */
    isBoxGoods (item = {}) {
      return item.pdTy === '06'
    },
    /**
     * 매장픽업전용 여부
     * 오직 pkupDdcatYn === 'Y' 일 때에만 노출한다.
     * (택배전용, 대량주문, 정기배송, 오늘배송 단 한개라도 중복되면 미노출) - 2024.12.24 정책
     * @type { function(Boolean, object): Boolean }
     */
    isPickupProduct (item = {}) {
      return item.pkupDdcatYn === 'Y' || item.onlyPkup === true || (Array.isArray(item.flag) && item.flag.includes('매장픽업전용'))
    },
    /**
     * 앱전용 여부
     * @type { function(object): Boolean }
     */
    isOnlyAppProduct (item = {}) {
      return item.appDdcatPdYn === 'Y' || item.APP_DDCAT_PD_YN === 'Y'
    },
    /**
     * 택배배송 가능 여부
     * @type { function(object): Boolean }
     */
    isPdsOrPsblYn (item = {}) {
      return item.pdsOrPsblYn === 'Y'
    },
    /**
     * 상품권 상품 여부
     * @type { function(object): Boolean }
     */
    isGfPd (item = {}) {
      return item.pdTy === '03' // 01:일반상품, 02:소모품, 03:상품권, 04:굿즈, 05:옵션상품, 06:박스상품
    },
    /**
     * 휴일배송 플래그 여부
     * 매장픽업전용 상품일 경우 노출하지 않는다. (정책 : DEV-5299)
     * @function
     * @param {Object} item - 상품 객체
     * @returns { Boolean } - 휴일배송 플래그 여부
     */
    isHolidayDelivery (item = {}) {
      if (!this.isPdsOrPsblYn(item) || this.isGfPd(item)) {
        return false
      }
      const info = this.$store.getters['ds/getHolidayDeliveryInfo']
      return info?.hldyDlvFlagYn === 'Y'
    },
    /**
     * 오늘배송전용 여부
     * @type { function(object): Boolean }
     */
    isOnlyQuickDeliveryProduct (item = {}) {
      return item.onlyQuickYn === 'Y' || item.ONLY_QUICK_YN === 'Y' || item.onlyQuickYn === true
    }
  }
}

export {
  rules
}
